import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";

export default class About extends Component {

    render() {
        const { about = "", background = "#" } = this.props;

        return (
            <section style={{ height: "75vh", backgroundImage: `url(${background})`, backgroundSize: "cover" }}>
                <Container className="h-100">
                    <Row className="h-100 d-flex align-items-center">
                        <Col xs={12} lg={6}>
                            <h2>Sobre nós</h2>
                            <p className="text-justify">{about}</p>
                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }
}